"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SectionColorCircle = function (_a) {
    var hex = _a.hex;
    return (react_1.default.createElement("div", { style: { backgroundColor: "#".concat(hex), width: "1.2em", height: "1.2em", borderRadius: "100%" } }));
};
exports.default = SectionColorCircle;
